import { Box, Link, Typography } from "@mui/material";
import type { MouseEvent } from "react";

import { useUser } from "../data/useUser";

export function LoginIndicator(): JSX.Element | null {
  const { user, clearUser } = useUser();

  if (!user) return null;

  const handleSwitch = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    clearUser();
    window.location.reload();
  };

  return (
    <Box sx={{ mb: 1.25, textAlign: "right" }}>
      <Typography component="span">{user}</Typography>
      <Link href="#" onClick={handleSwitch} sx={{ ml: 0.75 }}>
        switch
      </Link>
    </Box>
  );
}
